import classNames from '@prague-digi/class-names'
import get from 'lodash/get'
import React from 'react'
import { BContainer, BTitle } from '@prague-digi/ui-components'
import { CSSTransition } from 'react-transition-group'

import { PageControlButtons } from '../'
import {
  ModalDialogConfiguration,
  ModalDialogSeverityEnum,
} from '../../redux/reducers/modalDialog/model'

import styles from './styles.scss'

interface Props extends ModalDialogConfiguration {}

interface State {
  windowHeight: number
}

const cloneElement = ({ content, id }: Props) => {
  let newProps = {}

  if (
    typeof content === 'object' &&
    (!content.props ||
      (content.props && (Object.keys(content.props).length === 0 || 'modalId' in content.props)))
  ) {
    newProps = { modalId: id }
  }

  return React.cloneElement(content, newProps)
}

const severityStyles = {
  [ModalDialogSeverityEnum.Hint]: styles.hint,
  [ModalDialogSeverityEnum.Warning]: styles.warning,
  [ModalDialogSeverityEnum.Error]: styles.error,
  [ModalDialogSeverityEnum.Inactivity]: styles.inactivity,
}

export class ModalDialog extends React.Component<Props, State> {
  state: State = {
    windowHeight: 0,
  }

  componentDidMount() {
    window.addEventListener('resize', this.fetchWindowHeight)

    this.fetchWindowHeight()
  }

  componentDidUpdate(): void {
    this.fetchWindowHeight()
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.fetchWindowHeight)
  }

  onCloseButtonClick = () => {
    this.props.closeButton?.onClick && this.props.closeButton.onClick(this.props.id)
  }

  onSecondButtonClick = () => {
    this.props.secondButton?.onClick && this.props.secondButton.onClick(this.props.id)
  }

  fetchWindowHeight = () => {
    const windowHeight = get(document.body || document.documentElement, 'clientHeight')

    windowHeight !== this.state.windowHeight &&
      this.setState({
        windowHeight,
      })

    return windowHeight
  }

  render() {
    const scrollableContentStyle = {
      maxHeight: `${Math.max(0, this.state.windowHeight - 90)}px`,
    }

    const classNameModal = classNames(
      styles.modal,
      this.props.severity && severityStyles[this.props.severity]
    )

    return (
      <CSSTransition
        appear
        enter
        exit
        in={this.props.show}
        timeout={{
          appear: 0,
          enter: 0,
          exit: 300,
        }}
        classNames={{
          enterDone: styles.modalOpened,
          exit: styles.modalClosed,
        }}
        mountOnEnter
        unmountOnExit>
        <div className={classNameModal}>
          <BContainer
            className={styles.bootstrapContainer}
            style={{ width: this.props.preferredWidth || 'auto', overflow: 'auto' }}>
            <div className={styles.content}>
              {this.props.image && <div className={styles.center}>{this.props.image}</div>}
              <div className={styles.scrollableContent} style={scrollableContentStyle}>
                {this.props.title && (
                  <BTitle type="h3" center>
                    {this.props.title}
                  </BTitle>
                )}
                {this.props.content && (
                  <div
                    className={classNames(styles.bodyContainer, {
                      [styles.noFooter]: this.props.noFooter,
                      [styles.center]: this.props.centerContent,
                    })}>
                    {cloneElement(this.props)}
                  </div>
                )}
                {!this.props.noFooter && !this.props.customFooter && (
                  <PageControlButtons
                    onSubmit={this.onCloseButtonClick}
                    submitMessage={this.props.closeButton?.text}
                    secondaryAction={this.props.secondButton ? this.onSecondButtonClick : undefined}
                    secondaryMessage={
                      this.props.secondButton && this.props.secondButton.text
                        ? this.props.secondButton.text
                        : undefined
                    }
                  />
                )}
                {!this.props.noFooter && this.props.customFooter}
              </div>
            </div>
          </BContainer>
        </div>
      </CSSTransition>
    )
  }
}

export default ModalDialog
